<template>
  <div>
    <v-container>
      <h1>Reports</h1>
      <br />
      <v-row>
        <v-col xs="12" sm="6" md="6" :class="classPadding">
          <v-text-field
            label="Select Report"
            clearable
            :value="selectedReport.reportTitle"
            :class="classPadding"
            @click:clear="clear"
            readonly
          >
            <template slot="append">
              <v-icon @click.stop="dialog = true">mdi-magnify</v-icon>
            </template>
          </v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col xs="12" sm="12" md="12" :class="classPadding">
          <!-- DOLE -->
          <annual-medical
            v-if="selectedReport.reportCode == '001'"
          ></annual-medical>

          <exposure-data
            v-if="selectedReport.reportCode == '002'"
          ></exposure-data>

          <employee-work-accident
            v-if="selectedReport.reportCode == '003'"
          ></employee-work-accident>

          <roster-of-worker
            v-if="selectedReport.reportCode == '004'"
          ></roster-of-worker>

          <employee-info-isle
            v-if="selectedReport.reportCode == '005'"
          ></employee-info-isle>

          <!-- General  -->
          <account-and-salary
            v-if="selectedReport.reportCode == '006'"
          ></account-and-salary>
          <benefit v-if="selectedReport.reportCode == '007'"></benefit>
          <birthday-of-the-month
            v-if="selectedReport.reportCode == '008'"
          ></birthday-of-the-month>
          <coe-separated
            v-if="selectedReport.reportCode == '009'"
          ></coe-separated>
          <coe-compensation
            v-if="selectedReport.reportCode == '010'"
          ></coe-compensation>
          <coe-job-desc-history
            v-if="selectedReport.reportCode == '011'"
          ></coe-job-desc-history>
          <coe v-if="selectedReport.reportCode == '012'"></coe>
          <contract v-if="selectedReport.reportCode == '013'"></contract>
          <employee-info
            v-if="selectedReport.reportCode == '014'"
          ></employee-info>
          <employee-masterfile-info
            v-if="selectedReport.reportCode == '015'"
          ></employee-masterfile-info>

          <employee-masterfile-info2
            v-if="selectedReport.reportCode == '117'"
          ></employee-masterfile-info2>
          <employee-salary-report
            v-if="selectedReport.reportCode == '016'"
          ></employee-salary-report>
          <emp-seminar-training-recomm
            v-if="selectedReport.reportCode == '017'"
          ></emp-seminar-training-recomm>
          <employee-slip
            v-if="selectedReport.reportCode == '018'"
          ></employee-slip>
          <extension-of-contract
            v-if="selectedReport.reportCode == '019'"
          ></extension-of-contract>
          <identification-card
            v-if="selectedReport.reportCode == '020'"
          ></identification-card>
          <insurance v-if="selectedReport.reportCode == '021'"></insurance>
          <job-level-benefits
            v-if="selectedReport.reportCode == '022'"
          ></job-level-benefits>

          <employee-selected-fields
            v-if="selectedReport.reportCode == '023'"
          ></employee-selected-fields>

          <manpower-management
            v-if="selectedReport.reportCode == '024'"
          ></manpower-management>

          <manpower-plantilla
            v-if="selectedReport.reportCode == '025'"
          ></manpower-plantilla>
          <memorandum v-if="selectedReport.reportCode == '026'"></memorandum>
          <notice-to-explain
            v-if="selectedReport.reportCode == '027'"
          ></notice-to-explain>
          <personnel-emp-record
            v-if="selectedReport.reportCode == '028'"
          ></personnel-emp-record>

          <philhealth-employment
            v-if="selectedReport.reportCode == '029'"
          ></philhealth-employment>

          <project-personnel-clearance
            v-if="selectedReport.reportCode == '030'"
          ></project-personnel-clearance>

          <resume v-if="selectedReport.reportCode == '031'"></resume>
          <roster-of-employee
            v-if="selectedReport.reportCode == '032'"
          ></roster-of-employee>

          <sss-employment
            v-if="selectedReport.reportCode == '033'"
          ></sss-employment>

          <termination-contract
            v-if="selectedReport.reportCode == '034'"
          ></termination-contract>

          <years-of-service
            v-if="selectedReport.reportCode == '035'"
          ></years-of-service>

          <list-of-probi
            v-if="selectedReport.reportCode == '036'"
          ></list-of-probi>

          <pme-transaction
            v-if="selectedReport.reportCode == '037'"
          ></pme-transaction>

          <pme-level-report
            v-if="selectedReport.reportCode == '101'"
          ></pme-level-report>

          <onboarding v-if="selectedReport.reportCode == '120'"></onboarding>

          <employee-exit-clearance
            v-if="selectedReport.reportCode == '121'"
          ></employee-exit-clearance>

          <central-office-emp-agreement
            v-if="selectedReport.reportCode == '122'"
          ></central-office-emp-agreement>

          <field-supp-emp-agreement
            v-if="selectedReport.reportCode == '123'"
          ></field-supp-emp-agreement>

          <prob-emp-agreement
            v-if="selectedReport.reportCode == '124'"
          ></prob-emp-agreement>

          <notice-discip-action
            v-if="selectedReport.reportCode == '125'"
          ></notice-discip-action>

          <notice-termination
            v-if="selectedReport.reportCode == '126'"
          ></notice-termination>

          <hearing-notice
            v-if="selectedReport.reportCode == '127'"
          ></hearing-notice>

          <invitation-letter-admin-hearing
            v-if="selectedReport.reportCode == '128'"
          ></invitation-letter-admin-hearing>

          <!-- Monthly Personnel Inventory -->
          <list-of-emp-emp-cat
            v-if="selectedReport.reportCode == '038'"
          ></list-of-emp-emp-cat>

          <list-of-emp-emp-stat
            v-if="selectedReport.reportCode == '039'"
          ></list-of-emp-emp-stat>

          <monthly-personnel-inventory-counts
            v-if="selectedReport.reportCode == '040'"
          ></monthly-personnel-inventory-counts>
          <!-- Monthly Summmary Reports -->
          <licenses-expire
            v-if="selectedReport.reportCode == '041'"
          ></licenses-expire>

          <list-of-license
            v-if="selectedReport.reportCode == '042'"
          ></list-of-license>

          <list-of-affected-workers-by-displacement
            v-if="selectedReport.reportCode == '043'"
          ></list-of-affected-workers-by-displacement>

          <list-of-annual-physical-exam
            v-if="selectedReport.reportCode == '044'"
          ></list-of-annual-physical-exam>

          <list-of-beneficiaries-emp
            v-if="selectedReport.reportCode == '045'"
          ></list-of-beneficiaries-emp>

          <list-of-commendation-received
            v-if="selectedReport.reportCode == '046'"
          ></list-of-commendation-received>

          <list-of-emp-monthly-tenure
            v-if="selectedReport.reportCode == '047'"
          ></list-of-emp-monthly-tenure>

          <list-of-emp-per-field
            v-if="selectedReport.reportCode == '048'"
          ></list-of-emp-per-field>

          <exemption-report
            v-if="selectedReport.reportCode == '049'"
          ></exemption-report>

          <list-of-emp-per-movement-type-details
            v-if="selectedReport.reportCode == '050'"
          ></list-of-emp-per-movement-type-details>

          <list-of-emp-per-movement-type
            v-if="selectedReport.reportCode == '051'"
          ></list-of-emp-per-movement-type>

          <list-of-emp-location
            v-if="selectedReport.reportCode == '052'"
          ></list-of-emp-location>

          <list-of-emp-educ-back
            v-if="selectedReport.reportCode == '053'"
          ></list-of-emp-educ-back>

          <list-of-emp-exam-result
            v-if="selectedReport.reportCode == '054'"
          ></list-of-emp-exam-result>

          <list-of-emp-prev-emp
            v-if="selectedReport.reportCode == '055'"
          ></list-of-emp-prev-emp>

          <list-of-emp-expiration-date
            v-if="selectedReport.reportCode == '056'"
          ></list-of-emp-expiration-date>

          <list-of-emp-training-sem
            v-if="selectedReport.reportCode == '057'"
          ></list-of-emp-training-sem>

          <list-of-emp-end-contract
            v-if="selectedReport.reportCode == '058'"
          ></list-of-emp-end-contract>

          <list-of-emp-newly-hired
            v-if="selectedReport.reportCode == '059'"
          ></list-of-emp-newly-hired>

          <list-of-promoted-emp
            v-if="selectedReport.reportCode == '060'"
          ></list-of-promoted-emp>

          <list-of-resigned-emp
            v-if="selectedReport.reportCode == '061'"
          ></list-of-resigned-emp>

          <list-of-retirable-emp
            v-if="selectedReport.reportCode == '062'"
          ></list-of-retirable-emp>

          <list-of-separated-emp
            v-if="selectedReport.reportCode == '063'"
          ></list-of-separated-emp>

          <list-of-supervisors
            v-if="selectedReport.reportCode == '064'"
          ></list-of-supervisors>

          <list-of-terminated-emp-by-emp-cat
            v-if="selectedReport.reportCode == '065'"
          ></list-of-terminated-emp-by-emp-cat>

          <list-of-emp-tardiness
            v-if="selectedReport.reportCode == '066'"
          ></list-of-emp-tardiness>

          <manpower-complement-stat
            v-if="selectedReport.reportCode == '067'"
          ></manpower-complement-stat>

          <disciplinary-remarks
            v-if="selectedReport.reportCode == '102'"
          ></disciplinary-remarks>

          <document-submitted
            v-if="selectedReport.reportCode == '103'"
          ></document-submitted>

          <PerformanceEval
            v-if="selectedReport.reportCode == '130'"
          ></PerformanceEval>

          <EducationalBackground
            v-if="selectedReport.reportCode == '131'"
          ></EducationalBackground>

          <LicensesOtherEligibilities
            v-if="selectedReport.reportCode == '132'"
          ></LicensesOtherEligibilities>

          <ManpowerHeadCountSummary v-if="selectedReport.reportCode == '133'">
          </ManpowerHeadCountSummary>

          <EmpRegSalUp v-if="selectedReport.reportCode == '134'"></EmpRegSalUp>

          <narrative-report
            v-if="selectedReport.reportCode == '104'"
          ></narrative-report>

          <government-forms
            v-if="selectedReport.reportCode == '105'"
          ></government-forms>

          <government-exams
            v-if="selectedReport.reportCode == '106'"
          ></government-exams>

          <health-record
            v-if="selectedReport.reportCode == '107'"
          ></health-record>

          <language v-if="selectedReport.reportCode == '108'"></language>

          <medical-reimbursement
            v-if="selectedReport.reportCode == '109'"
          ></medical-reimbursement>

          <medical-cases
            v-if="selectedReport.reportCode == '110'"
          ></medical-cases>

          <memo-received
            v-if="selectedReport.reportCode == '111'"
          ></memo-received>

          <prev-emp v-if="selectedReport.reportCode == '112'"></prev-emp>

          <referral v-if="selectedReport.reportCode == '113'"></referral>

          <references v-if="selectedReport.reportCode == '114'"></references>

          <overseas-placement
            v-if="selectedReport.reportCode == '115'"
          ></overseas-placement>

          <specialization
            v-if="selectedReport.reportCode == '116'"
          ></specialization>

          <person-to-contact
            v-if="selectedReport.reportCode == '119'"
          ></person-to-contact>
          <!-- Employee Demographic Profile -->
          <analysis-by-job-gender
            v-if="selectedReport.reportCode == '068'"
          ></analysis-by-job-gender>

          <analysis-avg-age-employees
            v-if="selectedReport.reportCode == '069'"
          ></analysis-avg-age-employees>

          <analysis-avg-years-service
            v-if="selectedReport.reportCode == '070'"
          ></analysis-avg-years-service>

          <analysis-avg-years-service-by-age
            v-if="selectedReport.reportCode == '071'"
          ></analysis-avg-years-service-by-age>

          <analysis-emp-by-age-group-gender
            v-if="selectedReport.reportCode == '072'"
          ></analysis-emp-by-age-group-gender>

          <analysis-emp-by-age-group-job-level
            v-if="selectedReport.reportCode == '073'"
          ></analysis-emp-by-age-group-job-level>

          <count-all-employees
            v-if="selectedReport.reportCode == '074'"
          ></count-all-employees>

          <count-of-emp-by-age-tenure
            v-if="selectedReport.reportCode == '075'"
          ></count-of-emp-by-age-tenure>

          <count-of-emp-by-tenure-gender
            v-if="selectedReport.reportCode == '076'"
          ></count-of-emp-by-tenure-gender>

          <age-bracket-resigned-emp
            v-if="selectedReport.reportCode == '077'"
          ></age-bracket-resigned-emp>

          <emp-per-age v-if="selectedReport.reportCode == '078'"></emp-per-age>

          <!-- Employee Relations - Disc Cases -->
          <disc-profile
            v-if="selectedReport.reportCode == '079'"
          ></disc-profile>

          <disc-profile-emp
            v-if="selectedReport.reportCode == '080'"
          ></disc-profile-emp>

          <list-div-disc-sanction
            v-if="selectedReport.reportCode == '081'"
          ></list-div-disc-sanction>

          <list-div-wo-disc-sanction
            v-if="selectedReport.reportCode == '082'"
          ></list-div-wo-disc-sanction>

          <list-emp-disc-case-nature-offense
            v-if="selectedReport.reportCode == '083'"
          ></list-emp-disc-case-nature-offense>

          <list-emp-disc-case-type-offense
            v-if="selectedReport.reportCode == '084'"
          ></list-emp-disc-case-type-offense>

          <list-emp-disc-case-office-div-dep
            v-if="selectedReport.reportCode == '085'"
          ></list-emp-disc-case-office-div-dep>

          <list-emp-disc-case-with-ar
            v-if="selectedReport.reportCode == '086'"
          ></list-emp-disc-case-with-ar>

          <list-emp-issued-sanction
            v-if="selectedReport.reportCode == '087'"
          ></list-emp-issued-sanction>

          <list-emp-disc-case-by-status
            v-if="selectedReport.reportCode == '088'"
          ></list-emp-disc-case-by-status>

          <list-suspended-emp
            v-if="selectedReport.reportCode == '089'"
          ></list-suspended-emp>

          <count-offenses-dep-div-branch
            v-if="selectedReport.reportCode == '090'"
          ></count-offenses-dep-div-branch>

          <emp-bank-history
            v-if="selectedReport.reportCode == '091'"
          ></emp-bank-history>

          <emp-bank-list
            v-if="selectedReport.reportCode == '092'"
          ></emp-bank-list>

          <emp-cash-card
            v-if="selectedReport.reportCode == '093'"
          ></emp-cash-card>

          <list-emp-pending-admin-case
            v-if="selectedReport.reportCode == '094'"
          ></list-emp-pending-admin-case>

          <list-emp-sanctioned-disc-action
            v-if="selectedReport.reportCode == '095'"
          ></list-emp-sanctioned-disc-action>

          <list-emp-admin-case-resolved
            v-if="selectedReport.reportCode == '096'"
          ></list-emp-admin-case-resolved>

          <list-emp-admin-case
            v-if="selectedReport.reportCode == '097'"
          ></list-emp-admin-case>

          <list-offense-committed-emp
            v-if="selectedReport.reportCode == '098'"
          ></list-offense-committed-emp>

          <manpower-pool
            v-if="selectedReport.reportCode == '099'"
          ></manpower-pool>

          <user-access-privilege
            v-if="selectedReport.reportCode == '100'"
          ></user-access-privilege>

          <list-of-emp-km-ride
            v-if="selectedReport.reportCode == '118'"
          ></list-of-emp-km-ride>

          <AuditTrail v-if="selectedReport.reportCode == '129'"></AuditTrail>
          <ListOfEmpPerResType v-if="selectedReport.reportCode == '135'" />
        </v-col>
      </v-row>
    </v-container>

    <v-dialog v-model="dialog" width="900" persistent scrollable>
      <v-card>
        <v-card-title>
          <span class="headline">List of Reports</span>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
              <v-autocomplete
                label="Report Group"
                :items="groups"
                item-value="value"
                item-text="text"
                v-model="group"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>

          <v-data-table
            :items="filteredItems"
            :headers="headers"
            :search="search"
            :loading="loading"
          >
            <template v-slot:item.actions="{ item }">
              <v-btn text outlined @click.prevent="select(item)">Select</v-btn>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click.stop="dialog = false" text>CLose</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import isEmpty from "lodash/isEmpty";
import { mapActions } from "vuex";
// import YearsOfService from './general/YearsOfService.vue';

// DOLE
const AnnualMedical = () => import("./dole/AnnualMedical");
const ExposureData = () => import("./dole/ExposureData");
const RosterOfWorker = () => import("./dole/RosterOfWorkers");
const EmployeeWorkAccident = () => import("./dole/EmployeeWorkAccident");
const EmployeeInfoIsle = () => import("./dole/EmployeeInfoIsle");

// GENERAL
const AccountAndSalary = () => import("./general/AccountAndSalary");
const Benefit = () => import("./general/Benefit");
const BirthdayOfTheMonth = () => import("./general/BirthdayOfTheMonth");
const CoeSeparated = () => import("./general/COESeparated");
const CoeCompensation = () => import("./general/COECompensation");
const CoeJobDescHistory = () => import("./general/COEJobDescHistory");
const Coe = () => import("./general/COE");
const Contract = () => import("./general/Contract");
const EmployeeInfo = () => import("./general/EmployeeInformation");
const EmployeeMasterfileInfo = () => import("./general/EmployeeMasterfileInfo");
const EmployeeMasterfileInfo2 = () =>
  import("./general/EmployeeMasterfileInfo2");
const EmployeeSalaryReport = () => import("./general/EmployeeSalaryReport");
const PersonnelEmpRecord = () => import("./general/PersonnelEmpRecord");
const EmpSeminarTrainingRecomm = () =>
  import("./general/EmpSeminarTrainingRecomm");
const ExtensionOfContract = () => import("./general/ExtensionOfContract");
const IdentificationCard = () => import("./general/IdentificationCard");
const Insurance = () => import("./general/Insurance");

const EmployeeSlip = () => import("./general/EmployeeSlip");
const JobLevelBenefits = () => import("./general/JobLevelBenefits");
const EmployeeSelectedFields = () => import("./general/EmployeeSelectedFields");
const ManpowerManagement = () => import("./general/ManpowerManagement");
const ManpowerPlantilla = () => import("./general/ManpowerPlantilla");
const Memorandum = () => import("./general/Memorandum");
const NoticeToExplain = () => import("./general/NoticeToExplain");
const PhilhealthEmployment = () => import("./general/PhilhealthEmployment");
const Resume = () => import("./general/Resume");
const RosterOfEmployee = () => import("./general/RosterOfEmployee");
const SSSEmployment = () => import("./general/SSSEmployment");
const ProjectPersonnelClearance = () =>
  import("./general/ProjectPersonnelClearance");
const TerminationContract = () => import("./general/TerminationContract");
const YearsOfService = () => import("./general/YearsOfService");
const ListOfProbi = () => import("./general/ListOfProbi");
const PmeTransaction = () => import("./general/PmeTransaction");
const PmeLevelReport = () => import("./general/PmeLevelReport");
const Onboarding = () => import("./general/Onboarding");
const EmployeeExitClearance = () =>
  import("./general/EmployeeExitClearance.vue");
const CentralOfficeEmpAgreement = () =>
  import("./general/CentralOfficeEmpAgreement.vue");
const FieldSuppEmpAgreement = () =>
  import("./general/FieldSuppEmpAgreement.vue");

const ProbEmpAgreement = () => import("./general/ProbEmpAgreement.vue");
const NoticeDiscipAction = () => import("./general/NoticeDiscipAction.vue");
const NoticeTermination = () => import("./general/NoticeOfTermination.vue");
const HearingNotice = () => import("./general/HearingNotice.vue");
const InvitationLetterAdminHearing = () =>
  import("./general/InvitationLetterAdminHearing.vue");

const AuditTrail = () => import("./general/AuditTrail.vue");

// Monthly Personnel Inventory
const ListOfEmpEmpCat = () =>
  import("./monthly-personnel-inventory/ListOfEmpEmpCat");

const ListOfEmpEmpStat = () =>
  import("./monthly-personnel-inventory/ListOfEmpEmpStat");
const MonthlyPersonnelInventoryCounts = () =>
  import("./monthly-personnel-inventory/Counts");
// Monthly Summary Reports
const LicensesExpire = () => import("./monthly-summary/LicensesExpire");
const ListOfEmpPerField = () => import("./monthly-summary/ListOfEmpPerField");
const ListOfEmpPerMovementTypeDetails = () =>
  import("./monthly-summary/ListOfEmpPerMovementTypeDetails");
const ListOfEmpPerMovementType = () =>
  import("./monthly-summary/ListOfEmpPerMovementType");

const ListOfLicense = () => import("./monthly-summary/ListOfLicense");
const ListOfAffectedWorkersByDisplacement = () =>
  import("./monthly-summary/ListOfAffectedWorkersByDisplacement");

const ListOfAnnualPhysicalExam = () =>
  import("./monthly-summary/ListOfAnnualPhysicalExam");

const ListOfBeneficiariesEmp = () =>
  import("./monthly-summary/ListOfBeneficiaiesEmp");

const ListOfCommendationReceived = () =>
  import("./monthly-summary/ListOfCommendationReceived");

const ListOfEmpMonthlyTenure = () =>
  import("./monthly-summary/ListOfEmpMonthlyTenure");
const ExemptionReport = () => import("./monthly-summary/ExemptionReport");

const ListOfEmpLocation = () => import("./monthly-summary/ListOfEmpLocation");

const ListOfEmpEducBack = () => import("./monthly-summary/ListOfEmpEducBack");
const ListOfEmpExamResult = () =>
  import("./monthly-summary/ListOfEmpExamResult");
const ListOfEmpPrevEmp = () => import("./monthly-summary/ListOfEmpPrevEmp");
const ListOfEmpExpirationDate = () =>
  import("./monthly-summary/ListOfEmpExpirationDate");
const ListOfEmpTrainingSem = () =>
  import("./monthly-summary/ListOfEmpTrainingSem");
const ListOfEmpEndContract = () =>
  import("./monthly-summary/ListOfEmpEndContract");
const ListOfEmpNewlyHired = () =>
  import("./monthly-summary/ListOfEmpNewlyHired");

const ListOfResignedEmp = () => import("./monthly-summary/ListOfResignedEmp");

const ListOfRetirableEmp = () => import("./monthly-summary/ListOfRetirableEmp");

const ListOfPromotedEmp = () => import("./monthly-summary/ListOfPromotedEmp");
const ListOfSeparatedEmp = () => import("./monthly-summary/ListOfSeparatedEmp");
const ListOfSupervisors = () => import("./monthly-summary/ListOfSupervisors");
const ListOfTerminatedEmpByEmpCat = () =>
  import("./monthly-summary/ListOfTerminatedEmpByEmpCat");
const ListOfEmpTardiness = () => import("./monthly-summary/ListOfEmpTardiness");
const ManpowerComplementStat = () =>
  import("./monthly-summary/ManpowerComplementStat");

const DisciplinaryRemarks = () =>
  import("./monthly-summary/DisciplinaryRemarks.vue");

const DocumentSubmitted = () =>
  import("./monthly-summary/DocumentSubmitted.vue");

const PerformanceEval = () => import("./monthly-summary/PerformanceEval.vue");

const ManpowerHeadCountSummary = () =>
  import("./monthly-summary/ManpowerHeadCountSummary.vue");

const EmpRegSalUp = () => import("./monthly-summary/EmpRegSalUp.vue");

const LicensesOtherEligibilities = () =>
  import("./monthly-summary/LicensesOtherEligibilities.vue");

const EducationalBackground = () =>
  import("./monthly-summary/EducationalBackground.vue");

const ListOfEmpPerResType = () =>
  import("./monthly-summary/ListOfEmpPerResType.vue");

const NarrativeReport = () => import("./monthly-summary/NarrativeReport.vue");

const GovernmentForms = () => import("./monthly-summary/GovernmentForms.vue");

const GovernmentExams = () => import("./monthly-summary/GovermentExams.vue");

const HealthRecord = () => import("./monthly-summary/HealthRecord.vue");

const Language = () => import("./monthly-summary/Language.vue");

const MedicalReimbursement = () =>
  import("./monthly-summary/MedicalReimbursement.vue");

const MedicalCases = () => import("./monthly-summary/MedicalCases.vue");
const MemoReceived = () => import("./monthly-summary/MemoReceived.vue");
const PrevEmp = () => import("./monthly-summary/PrevEmp.vue");
const Referral = () => import("./monthly-summary/Referral.vue");
const References = () => import("./monthly-summary/References.vue");
const OverseasPlacement = () =>
  import("./monthly-summary/OverseasPlacement.vue");
const Specialization = () => import("./monthly-summary/Specialization.vue");

const PersonToContact = () => import("./monthly-summary/PersonToContact.vue");
// Employee Demographic Profile
const CountAllEmployees = () =>
  import("./employee-demo-profile/CountAllEmployees");
const AnalysisByJobGender = () =>
  import("./employee-demo-profile/AnalysisByJobGender");

const AnalysisAvgAgeEmployees = () =>
  import("./employee-demo-profile/AnalysisAvgAgeEmployees");

const AnalysisAvgYearsService = () =>
  import("./employee-demo-profile/AnalysisAvgYearsSerivce");
const AnalysisAvgYearsServiceByAge = () =>
  import("./employee-demo-profile/AnalysisAvgYearsSerivceByAge");
const AnalysisEmpByAgeGroupGender = () =>
  import("./employee-demo-profile/AnalysisEmpByAgeGroupGender");
const AnalysisEmpByAgeGroupJobLevel = () =>
  import("./employee-demo-profile/AnalysisEmpByAgeGroupJobLevel");
const CountOfEmpByAgeTenure = () =>
  import("./employee-demo-profile/CountOfEmpByAgeTenure");
const CountOfEmpByTenureGender = () =>
  import("./employee-demo-profile/CountOfEmpByTenureGender");
const AgeBracketResignedEmp = () =>
  import("./employee-demo-profile/AgeBracketResignedEmp");

const EmpPerAge = () => import("./employee-demo-profile/EmpPerAge");
/* Employee Relations - Disciplinary Cases */

const DiscProfile = () => import("./employee-relations/DiscProfile");
const DiscProfileEmp = () => import("./employee-relations/DiscProfileEmp");
const ListDivDiscSanction = () =>
  import("./employee-relations/ListDivDiscSanction");
const ListDivWoDiscSanction = () =>
  import("./employee-relations/ListDivWoDiscSanction");
const ListEmpDiscCaseNatureOffense = () =>
  import("./employee-relations/ListEmpDiscCaseNatureOffense");
const ListEmpDiscCaseTypeOffense = () =>
  import("./employee-relations/ListEmpDiscCaseTypeOffense");
const ListEmpDiscCaseOfficeDivDep = () =>
  import("./employee-relations/ListEmpDiscCaseOfficeDivDep");
const ListEmpDiscCaseWithAr = () =>
  import("./employee-relations/ListEmpDiscCaseWithAr");
const ListEmpIssuedSanction = () =>
  import("./employee-relations/ListEmpIssuedSanction");
const ListEmpDiscCaseByStatus = () =>
  import("./employee-relations/ListEmpDiscCaseByStatus");

const ListSuspendedEmp = () => import("./employee-relations/ListSuspendedEmp");

/* Report Updating - Others */
const CountOffensesDepDivBranch = () =>
  import("./report-updating/CountOffensesDepDivBranch");
const EmpBankHistory = () => import("./report-updating/EmpBankHistory");
const EmpBankList = () => import("./report-updating/EmpBankList");
const EmpCashCard = () => import("./report-updating/EmpCashCard");
const ListEmpPendingAdminCase = () =>
  import("./report-updating/ListEmpPendingAdminCase");
const ListEmpSanctionedDiscAction = () =>
  import("./report-updating/ListEmpSanctionedDiscAction");

const ListEmpAdminCaseResolved = () =>
  import("./report-updating/ListEmpAdminCaseResolved");

const ListEmpAdminCase = () => import("./report-updating/ListEmpAdminCase");
const ListOffenseCommittedEmp = () =>
  import("./report-updating/ListOffenseCommittedEmp");
const ManpowerPool = () => import("./report-updating/ManpowerPool");

const UserAccessPrivilege = () => import("./user-access/UserAccessPrivilege");

const ListOfEmpKmRide = () =>
  import("./general/ListOfEmpDetailsByKmRidesAssignment");
const API_ENDPOINT = "/api/reports";
export default {
  metaInfo: {
    title: "Reports",
    titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
  },
  data: () => ({
    dialog: false,
    classPadding: "my-0 py-0",
    items: [],
    headers: [
      {
        text: "",
        value: "actions",
        sortable: false
      },
      {
        text: "Code",
        value: "reportCode",
        sortable: false
      },
      {
        text: "Title",
        value: "reportTitle",
        sortable: false
      }
    ],
    search: null,
    loading: false,
    selectedReport: {},
    groups: [
      {
        text: "All",
        value: "all"
      },
      {
        text: "DOLE",
        value: "DOLE"
      },
      {
        text: "General",
        value: "GEN"
      },
      {
        text: "Monthly Personnel Inventory",
        value: "MPI"
      },
      {
        text: "Monthly Summary",
        value: "MSR"
      },
      {
        text: "Employee Demograhic Profile",
        value: "EDP"
      },
      {
        text: "Employee Relations - Disciplinary Cases",
        value: "ERD"
      },
      {
        text: "Report Updating - Others",
        value: "RUO"
      },
      {
        text: "User Access",
        value: "UA"
      }
    ],
    group: "all"
  }),
  components: {
    AuditTrail,
    AnnualMedical,
    ExposureData,
    RosterOfWorker,
    EmployeeWorkAccident,
    EmployeeInfoIsle,
    AccountAndSalary,
    Benefit,
    BirthdayOfTheMonth,
    CoeSeparated,
    CoeCompensation,
    CoeJobDescHistory,
    Coe,
    Contract,
    EmployeeInfo,
    EmployeeMasterfileInfo,
    EmployeeMasterfileInfo2,
    PersonnelEmpRecord,
    EmployeeSalaryReport,
    EmpSeminarTrainingRecomm,
    EmployeeSlip,
    ExtensionOfContract,
    IdentificationCard,
    Insurance,
    JobLevelBenefits,
    EmployeeSelectedFields,
    ManpowerManagement,
    ManpowerPlantilla,
    Memorandum,
    NoticeToExplain,
    PhilhealthEmployment,
    Resume,
    RosterOfEmployee,
    SssEmployment: SSSEmployment,
    ListOfEmpPerField,
    ListOfEmpPerMovementTypeDetails,
    ListOfEmpPerMovementType,
    CountAllEmployees,
    ProjectPersonnelClearance,
    TerminationContract,
    YearsOfService,
    ListOfProbi,
    ListOfEmpEmpCat,
    ListOfEmpEmpStat,
    MonthlyPersonnelInventoryCounts,
    LicensesExpire,
    ListOfLicense,
    ListOfAffectedWorkersByDisplacement,
    ListOfAnnualPhysicalExam,
    ListOfBeneficiariesEmp,
    ListOfCommendationReceived,
    ListOfEmpMonthlyTenure,
    ExemptionReport,
    ListOfEmpLocation,
    ListOfEmpEducBack,
    ListOfEmpExamResult,
    ListOfEmpPrevEmp,
    ListOfEmpExpirationDate,
    ListOfEmpTrainingSem,
    ListOfEmpEndContract,
    ListOfEmpNewlyHired,
    ListOfPromotedEmp,
    ListOfResignedEmp,
    ListOfRetirableEmp,
    ListOfSeparatedEmp,
    ListOfSupervisors,
    ListOfTerminatedEmpByEmpCat,
    ListOfEmpTardiness,
    ManpowerComplementStat,
    AnalysisByJobGender,
    AnalysisAvgAgeEmployees,
    AnalysisAvgYearsService,
    AnalysisAvgYearsServiceByAge,
    AnalysisEmpByAgeGroupGender,
    AnalysisEmpByAgeGroupJobLevel,
    CountOfEmpByAgeTenure,
    CountOfEmpByTenureGender,
    AgeBracketResignedEmp,
    EmpPerAge,
    DiscProfile,
    DiscProfileEmp,
    ListDivDiscSanction,
    ListDivWoDiscSanction,
    ListEmpDiscCaseNatureOffense,
    ListEmpDiscCaseTypeOffense,
    ListEmpDiscCaseOfficeDivDep,
    ListEmpDiscCaseWithAr,
    ListEmpIssuedSanction,
    ListEmpDiscCaseByStatus,
    ListSuspendedEmp,
    ListOfEmpPerResType,
    CountOffensesDepDivBranch,
    EmpBankHistory,
    EmpBankList,
    EmpCashCard,
    ListEmpPendingAdminCase,
    ListEmpSanctionedDiscAction,
    ListEmpAdminCaseResolved,
    ListEmpAdminCase,
    ListOffenseCommittedEmp,
    ManpowerPool,
    UserAccessPrivilege,
    PmeTransaction,
    PmeLevelReport,
    DisciplinaryRemarks,
    DocumentSubmitted,
    PerformanceEval,
    EducationalBackground,
    LicensesOtherEligibilities,
    ManpowerHeadCountSummary,
    EmpRegSalUp,
    NarrativeReport,
    GovernmentForms,
    GovernmentExams,
    HealthRecord,
    Language,
    MedicalReimbursement,
    MedicalCases,
    MemoReceived,
    PrevEmp,
    Referral,
    References,
    OverseasPlacement,
    Specialization,
    ListOfEmpKmRide,
    PersonToContact,
    Onboarding,
    EmployeeExitClearance,
    CentralOfficeEmpAgreement,
    FieldSuppEmpAgreement,
    ProbEmpAgreement,
    NoticeDiscipAction,
    NoticeTermination,
    HearingNotice,
    InvitationLetterAdminHearing
  },
  computed: {
    filteredItems() {
      if (this.group == "all") return this.items;
      else {
        return this.items.filter(item => {
          return item.group == this.group;
        });
      }
    }
  },
  methods: {
    ...mapActions("other", ["getClient"]),
    getAll() {
      this.loading = true;
      this.$axios
        .get(`${API_ENDPOINT}`)
        .then(({ data }) => {
          this.items = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    view() {
      if (isEmpty(this.selectedReport)) {
        this.$toast.error("Please select a report.");
        return;
      }
    },
    select(item) {
      this.dialog = false;
      this.selectedReport = Object.assign({}, item);
    },
    clear() {
      this.selectedReport = {};
    }
  },
  created() {
    this.getAll();
    this.getClient();
  }
};
</script>
